import api from "@/lib/api"
import type { AdminAddMemberInput, StudentCandidate } from "@/lib/api/cccdAdminClient"

// cccd-team-member-student-link: helpers used by the inline "add member"
// search bar (AddMemberSearchBar, on TeamDetailPage) — a known candidate
// always gets added to the team immediately, with whatever data is known;
// the rest of the intake ficha (documento, dirección, salud, consentimiento)
// is optional and gets completed later from the team, never by blocking the
// add itself.

export const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

export function kindLabel(kind: StudentCandidate["kind"]) {
  return kind === "user" ? "cuenta de Academy" : "reserva sin cuenta todavía"
}

// Builds the POST /members payload for a known candidate: the full
// previousMember ficha when the account's StudentProfile already covers it,
// or just name/email/phone (everything else left unset) otherwise — either
// way this is always enough to create the team-member relation right away.
export function memberInputFromCandidate(candidate: StudentCandidate): AdminAddMemberInput {
  if (candidate.previousMember) {
    return {
      ...candidate.previousMember,
      email: candidate.email,
      userId: candidate.kind === "user" ? candidate.userId : undefined,
      pendingMemberId: candidate.kind === "pending" ? candidate.pendingMemberId : undefined,
    }
  }
  const [firstName, ...rest] = candidate.name.trim().split(/\s+/)
  return {
    email: candidate.email,
    firstName: firstName ?? null,
    lastName: rest.join(" ") || null,
    phone: candidate.phone ?? null,
    userId: candidate.kind === "user" ? candidate.userId : undefined,
    pendingMemberId: candidate.kind === "pending" ? candidate.pendingMemberId : undefined,
  }
}

// Nadie tenía cuenta con ese correo: se crea una cuenta de estudiante nueva
// (nombre + correo, contraseña temporal) para que la persona ya exista con
// un id real — la ruta para llenar el resto de su información SIEMPRE es
// /instructor/students/:id/perfil, sin importar si la cuenta se creó desde
// el panel de Estudiantes o desde "agregar miembro" de un equipo CCCD que no
// encontró coincidencias (cccd-team-member-student-link).
export async function createStudentAccount(name: string, email: string): Promise<{ id: string; name: string; email: string }> {
  const res = await api.post<{ data: { id: string; name: string; email: string } }>("/admin/users", { name, email })
  return res.data.data
}
